/* eslint-disable no-underscore-dangle,prefer-const,padding-line-between-statements,react/destructuring-assignment,react/prop-types,spaced-comment,vars-on-top,no-var,prefer-template,class-methods-use-this,eqeqeq,lines-between-class-members,object-shorthand,react/sort-comp,no-unused-vars,react/jsx-curly-brace-presence,react/no-danger,react/no-unknown-property,no-plusplus,jsx-a11y/anchor-is-valid,no-script-url,jsx-a11y/no-noninteractive-tabindex,react/no-array-index-key */
import React, { Component } from 'react';
import SpeedBumpModal from '../../common/components/SpeedBumpModal';
import '../styles/footer.scss';

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.target = '';
    this.state = { showSpeedBump: false };

    this._handleResize = this._handleResize.bind(this);
    // this._updateBackgroundImage = this._updateBackgroundImage.bind(this);
    this.addPaddingToTheBottomOfFootersParent = this.addPaddingToTheBottomOfFootersParent.bind(
      this
    );

    window.addEventListener('resize', this._handleResize);
  }

  componentDidMount() {
    setTimeout(() => this._handleResize(), 500);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResize);
  }

  _handleResize() {
    this.addPaddingToTheBottomOfFootersParent();
  }

  // _updateBackgroundImage() {
  //     let footerSibling = document.getElementById('footerSibling');
  //     if (footerSibling) {
  //         footerSibling.setAttribute('class', this.props.backgroundImage);
  //     }
  // }

  //ref: http://cssreset.com/how-to-keep-footer-at-bottom-of-page-with-css/
  addPaddingToTheBottomOfFootersParent() {
    //This will allow footer to stop moving/overlap when browser window is shrink vertically
    let footer = document.getElementById('footer-container');
    let footerSibling = document.getElementById('footerSibling');

    if (footer && !this._isDisplaySetToNone(footer)) {
      if (!footerSibling) {
        var siblingDiv = document.createElement('div');
        siblingDiv.setAttribute('id', 'footerSibling');
        // siblingDiv.setAttribute('class', this.props.backgroundImage);
        siblingDiv.style['padding-bottom'] = footer.offsetHeight + 20 + 'px';
        footer.parentNode.insertBefore(siblingDiv, footer);
      } else {
        footerSibling.style['padding-bottom'] = footer.offsetHeight + 20 + 'px';
      }
    }
  }

  _isDisplaySetToNone(el) {
    var styleObj;
    if (typeof window.getComputedStyle != 'undefined') {
      styleObj = window.getComputedStyle(el, null);
    } else if (el.currentStyle != 'undefined') {
      styleObj = el.currentStyle;
    }
    return styleObj.display === 'none';
  }
  _onKeyPressLink(e) {
    let isUrl = e.currentTarget.childNodes[0].getAttribute('data-url');
    if (e.keyCode == 13) {
      if (isUrl) {
        if (this._isSameDomain(isUrl)) {
          this._openURL(isUrl);
        } else {
          this.target = e.target;
          setTimeout(() => {
            this.setState({ showSpeedBump: true, url: isUrl });
          }, 50);
        }
      }
    }
  }
  _onClickLink(evt) {
    let url = evt.target.getAttribute('data-url');
    evt.preventDefault();
    if (url) {
      if (this._isSameDomain(url)) {
        this._openURL(url);
      } else {
        this.target = evt.target;
        this.setState({ showSpeedBump: true, url: url });
      }
    }
  }

  _isSameDomain(url) {
    return (
      /^https?:/.test(url) &&
      url.search(
        RegExp('^https?\\:\\/\\/' + document.location.hostname, 'i')
      ) === 0
    );
  }

  _openURL(url) {
    window.open(url, '_blank');
  }

  _onOkClick() {
    this._openURL(this.state.url);
    this.setState({ showSpeedBump: false, url: '' });
  }

  _onCancelClick() {
    if (this.target) {
      this.target.focus();
    }
    this.setState({ showSpeedBump: false, url: '' });
  }
  _closeHandlerOnEsc(event) {
    if (event.keyCode == 27) {
      if (this.target) {
        this.target.focus();
      }
      this.setState({ showSpeedBump: false, url: '' });
    }
  }
  render() {
    let that = this;
    let speedBumpHandlers = {
      onOkClick: this._onOkClick.bind(that),
      onCancelClick: this._onCancelClick.bind(that),
      onEscKey: this._closeHandlerOnEsc.bind(that),
    };

    let data = this.props.config || this.props || {};
    let middleText = [];

    const reactAppContext =
      process.env.REACT_APP_CONTEXT === '/'
        ? ''
        : process.env.REACT_APP_CONTEXT;

    if (data.fiFooterStaticText) {
      middleText.push(
        <div className={'middle-text'}>
          <div
            className={'col-xs-12 text middle-text-in'}
            dangerouslySetInnerHTML={{
              __html: data.fiFooterStaticText,
            }}
          />
        </div>
      );
    }
    return (
      <div
        title='Footer Navigation'
        id='footer-container'
        role='contentinfo'
        className={'container-fluid footer-container-main'}
        tabindex='-1'
        aria-describedby='footer-container'
      >
        {this.state && this.state.showSpeedBump ? (
          <SpeedBumpModal
            handlers={speedBumpHandlers}
            config={this.props.config.speedbumpConfig}
          />
        ) : null}
          <>
            {this._generateFirstRow(data.fiFooterTextLinks)}
            {middleText}
            {this._generateThirdRow(data.fiFooterLinks)}
          </>
      </div>
    );
  }

  _generateThirdRow(data) {
    let markup = [];
    const reactAppContext =
      process.env.REACT_APP_CONTEXT === '/'
        ? ''
        : process.env.REACT_APP_CONTEXT;

    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        let item = data[index];
        let alt = item.alt ? item.alt : '';
        markup.push(
          <div
            className={'image-column'}
            key={'il-' + index}
            role='application'
          >
            <a
              tabindex='-1'
              href='javascript:void(0)'
              onClick={this._onClickLink.bind(this)}
              onMouseDown={this._onClickLink.bind(this)}
              onKeyDown={this._onKeyPressLink.bind(this)}
              aria-haspopup='true'
            >
              <img
                tabindex='0'
                id={item.link + index}
                alt={alt}
                src={item.image}
                data-url={item.link}
              />
            </a>
          </div>
        );
      }
      markup = <div className={'image-links'}>{markup}</div>;
    } else {
      markup = (
        <div className={'image-links'}>
          <div
            className={'intuit-logo logo-cls ' + 'di-logo' + ' di-logo-footer'}
          >
            <img
              tabindex='0'
              src={`${reactAppContext}/static/images/di-logo.svg`}
              alt='Powered by Digital Insight, an NCR company'
              className={'logo-image'}
            />
          </div>
        </div>
      );
    }

    return markup;
  }

  _generateFirstRow(data) {
    let headerLinksStaticText = [];

    if (data) {
      data.forEach((footerTextlinks, index) => {
        if (footerTextlinks) {
          if (footerTextlinks.links) {
            let headers = [];
            let links = [];
            let staticContent = [];
            let hasHeader = false;
            footerTextlinks.links.forEach((footerTextlink, linkIndex) => {
              if (footerTextlink.header) {
                hasHeader = true;
                headers.push(
                  <h2
                    className={'head'}
                    key={'footer-text-link-header' + linkIndex + '-' + index}
                  >
                    {footerTextlink.header}
                  </h2>
                );
              }

              if (footerTextlink.url) {
                let anchorTag = (
                  <a
                    href='javascript:void(0)'
                    id={footerTextlink.url}
                    onClick={this._onClickLink.bind(this)}
                    onMouseDown={this._onClickLink.bind(this)}
                    key={'footer-text-link-a' + linkIndex + '-' + index}
                    onKeyDown={this._onKeyPressLink.bind(this)}
                    aria-haspopup='true'
                    data-url={footerTextlink.url}
                  >
                    {footerTextlink.text}
                  </a>
                );

                if (footerTextlink.url.toLowerCase().indexOf('http') !== 0) {
                  let unescapedURL = this._decodeHTML(footerTextlink.url);
                  anchorTag = (
                    <a
                      href={unescapedURL}
                      key={'footer-text-link-a' + linkIndex + '-' + index}
                    >
                      {footerTextlink.text}
                    </a>
                  );
                }

                links.push(
                  <div
                    className={'footer-link'}
                    key={'footer-text-link-div' + linkIndex + '-' + index}
                  >
                    {anchorTag}
                  </div>
                );
              }

              if (footerTextlink.staticContent) {
                staticContent.push(
                  <div
                    className={'staticContent'}
                    key={
                      'footer-text-link-static-content' +
                      linkIndex +
                      '-' +
                      index
                    }
                  >
                    {footerTextlink.staticContent}
                  </div>
                );
              }
            });
            if (
              !hasHeader &&
              (staticContent.length != 0 || links.length != 0)
            ) {
              headers.push(
                <h2
                  className={'hidden-xs head'}
                  key={'footer-text-link-no-header' + '-' + index}
                >
                  &nbsp;
                </h2>
              );
            }

            if (
              headers.length != 0 ||
              staticContent.length != 0 ||
              links.length != 0
            ) {
              headerLinksStaticText.push(
                <div
                  className={'fi-footer-text-links text-link-coloumn'}
                  key={'footer-text-link-' + index}
                >
                  {headers}
                  {staticContent}
                  {links}
                </div>
              );
            }
          }
        }
      });
    }

    return headerLinksStaticText;
  }

  _decodeHTML(value) {
    let div = document.createElement('div');
    div.innerHTML = value;
    return div.innerHTML;
  }
}
